import { cn } from '@/lib/cn';

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-block size-6 animate-spin rounded-full border-[3px] border-brand-200 border-t-brand-600',
        className,
      )}
    />
  );
}

export function Loading({ label }: { label: string }) {
  return (
    <div
      role="status"
      className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-ink-muted"
    >
      <Spinner className="size-10" />
      <span>{label}</span>
    </div>
  );
}
